<template>
  <b-modal id="delete-news-image-modal" title="Delete News Image">
    <p class="modal-main-message">Are you sure you want delete this image?</p>
    <div slot="modal-footer">
      <b-btn
        variant="ghost"
        class="mr-1 btn-cancel"
        @click="$root.$emit('bv::hide::modal', 'delete-news-image-modal')"
      >
        Cancel
      </b-btn>
      <b-btn variant="primary" class="ml-1" @click="onDelete">
        Yes, Delete
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "DeleteNewsImageModal",
  methods: {
    ...mapMutations("engagementNews", ["setNewsImage"]),
    onDelete() {
      this.setNewsImage(null);
      this.$root.$emit("bv::hide::modal", "delete-news-image-modal");
    },
  },
};
</script>

<style>
</style>